const map = {
	"./5052938.png": 6541,
	"./751463.png": 9661,
	"./9413250.png": 791,
	"./For more info.png": 6203,
	"./For your info.png": 5333,
	"./Learn More.png": 4230,
	"./More information.png": 98,
	"./New Content.png": 318,
	"./New Contents.png": 9255,
	"./Note.png": 9939,
	"./Papers - Past.png": 319,
	"./Past Paper.png": 2405,
	"./Past Papers.png": 9194,
	"./Quest n Answrs.png": 9701,
	"./Questionaires.png": 995,
	"./REF Txt Book.png": 2777,
	"./Ref Text Book.png": 9928,
	"./Refer Text Book.png": 9693,
	"./Refer Txt Book.png": 5954,
	"./Refer.png": 9629,
	"./Review.png": 7643,
	"./Updated Contents.png": 7830,
	"./arrow (1).png": 4158,
	"./arrow (2).png": 5375,
	"./arrow (3).png": 7640,
	"./arrow (4).png": 1321,
	"./arrow-right (1).png": 1379,
	"./arrow-right.png": 4453,
	"./book (1).png": 6410,
	"./book (10).png": 4562,
	"./book (2).png": 363,
	"./book (3).png": 7940,
	"./book (4).png": 3405,
	"./book (5).png": 6086,
	"./book (6).png": 1767,
	"./book (7).png": 4784,
	"./book (8).png": 6569,
	"./book (9).png": 7058,
	"./book-marker.png": 9105,
	"./book.png": 2728,
	"./books.png": 4337,
	"./documentation.png": 1009,
	"./documents.png": 4413,
	"./dots (1).png": 9985,
	"./dots (2).png": 756,
	"./dots.png": 9763,
	"./double-arrow (1).png": 1150,
	"./double-arrow (2).png": 6015,
	"./double-arrow (3).png": 4360,
	"./double-arrow (4).png": 8313,
	"./double-arrow.png": 2620,
	"./double-arrows.png": 4362,
	"./double-right-arrow.png": 525,
	"./downloading (1).png": 8765,
	"./downloading.png": 9423,
	"./exam (1).png": 2000,
	"./exam.png": 1790,
	"./file.png": 8293,
	"./flower (1).png": 5660,
	"./flower.png": 7098,
	"./full-stop (1).png": 2293,
	"./full-stop (2).png": 7080,
	"./full-stop (3).png": 8735,
	"./full-stop.png": 5015,
	"./hotel-book.png": 2207,
	"./idea (1).png": 7480,
	"./learning (1).png": 5271,
	"./learning.png": 3817,
	"./light-bulb (1).png": 8949,
	"./light-bulb.png": 903,
	"./lightbulb (2).png": 85,
	"./lightbulb (3).png": 7886,
	"./logout (2).png": 5570,
	"./logout (3).png": 3801,
	"./logout (4).png": 9848,
	"./menu (1).png": 436,
	"./menu (2).png": 1217,
	"./menu (3).png": 7706,
	"./menu.png": 8834,
	"./no hovering (2).png": 2229,
	"./no hovering (3).png": 30,
	"./no hovering.png": 2454,
	"./notebook.png": 9092,
	"./open-book.png": 937,
	"./paper.png": 3025,
	"./pencil.png": 6344,
	"./period (1).png": 5862,
	"./period (2).png": 1543,
	"./period (3).png": 1808,
	"./period (4).png": 6657,
	"./period (5).png": 1226,
	"./period.png": 9412,
	"./point-on-the-right.png": 748,
	"./publication (1).png": 439,
	"./publication.png": 249,
	"./question.png": 2355,
	"./reading-book.png": 3013,
	"./refresh.png": 2486,
	"./reload.png": 8344,
	"./right-arrow (1).png": 6667,
	"./right-arrow (2).png": 1514,
	"./right-arrow.png": 1341,
	"./send-message (1).png": 4405,
	"./send-message (2).png": 904,
	"./send-message.png": 7239,
	"./shopping-list.png": 2142,
	"./sri-lanka.png": 1933,
	"./study.png": 1056,
	"./time-management (1).png": 5684,
	"./time-management.png": 6290,
	"./transfer (1).png": 496,
	"./transfer.png": 8302,
	"./triple-right-arrow.png": 2578,
	"./up-arrow.png": 92,
	"./updated.png": 2026,
	"./video-lesson.png": 2477,
	"./whats-new (1).png": 6121,
	"./whats-new.png": 2571
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9870;